import { GameId } from '@bg-shared/enums/GameId';
import { httpClientRepository } from '@bg-shared/infrastructure/HttpClient';
import { API_URLS } from '@bg-shared/constants/apiUrls';
import { IPayoutOptions } from '@bg-shared/interfaces';
import { IGameOptionsConfig, ILegacyOptionsConfig } from './interfaces';

export default class GamesOptionsApi {
    public getOptionsConfigs(
        gameIds: GameId[],
        partnerCode: string,
    ): Promise<Record<number, ILegacyOptionsConfig>> {
        return httpClientRepository
            .get<IGameOptionsConfig[]>(`${API_URLS.GAMES_OPTIONS}/${partnerCode}`, {
                params: {
                    gameIds,
                },
            })
            .then((res) =>
                Object.fromEntries(
                    res.map((game) => [
                        game.gameId,
                        {
                            preset: game.presetId,
                            items: game.items,
                            data: game.data,
                            groups: game.groups,
                        },
                    ]),
                ),
            )
            .catch(() => ({})); // In case of gameIds absence (PLS) return empty object
    }

    public getFirstRoundPayouts(gameId: GameId): Promise<IPayoutOptions> {
        return httpClientRepository.get(`${API_URLS.GAME_PAYOUTS}/${gameId}`);
    }
}

export const gamesOptionsApi = new GamesOptionsApi();
